import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth.store'
import type { UserRole } from '@/types'

const ROLE_HIERARCHY: Record<UserRole, number> = {
  SUPER_ADMIN: 7,
  ADMIN:       6,
  MANAGER:     5,
  ANALYST:     4,
  AUDITOR:     3,
  CLIENT:      2,
  VIEWER:      1,
}

interface ProtectedRouteProps {
  children: React.ReactNode
  minRole?: UserRole
}

export function ProtectedRoute({ children, minRole }: ProtectedRouteProps) {
  const { isAuthenticated, user } = useAuthStore()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (minRole && user) {
    const userLevel = ROLE_HIERARCHY[user.role] ?? 0
    const requiredLevel = ROLE_HIERARCHY[minRole] ?? 0
    if (userLevel < requiredLevel) {
      return <Navigate to="/dashboard" replace />
    }
  }

  return <>{children}</>
}
